import {
  getEntityInstanceHistory,
  getPyloUsersByIds,
} from "@/services/entity-instance-history.service";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

export const useEntityInstanceHistory = ({
  entityName,
  entityInstanceId,
  perPage = 50,
}: {
  entityName: string;
  entityInstanceId?: string;
  perPage?: number;
}) =>
  useInfiniteQuery({
    queryKey: ["entity-instance-history", entityName, entityInstanceId, perPage],
    enabled: !!entityInstanceId,
    queryFn: ({ pageParam }) =>
      getEntityInstanceHistory({
        entityName,
        entityInstanceId: entityInstanceId!,
        page: pageParam,
        perPage,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.has_more_pages ? lastPage.pagination.current_page + 1 : undefined,
    // History events flow through RabbitMQ → ClickHouse with a few seconds of
    // ingest lag, and a recent edit may not be visible immediately. Always
    // refetch on mount so reopening the modal/popover gets fresh data.
    refetchOnMount: "always",
    staleTime: 0,
  });

export const usePyloUsersByIds = (ids: string[]) =>
  useQuery({
    queryKey: ["pylo-users-by-ids", [...ids].sort()],
    enabled: ids.length > 0,
    queryFn: () => getPyloUsersByIds(ids),
    staleTime: 60_000,
  });
